import React from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, ChevronRight } from "lucide-react";
import { useLang } from "../../hooks/useLang";

const ContinueLearning = ({ item }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  if (!item) return null;

  const handleContinue = () => {
    navigate(urlLanguage(`/material/${item.id}`));
  };

  return (
    <div className="mb-6 animate-fade-in">
      <h2 className="section-title mb-3 uppercase tracking-wider">Continue Learning</h2>
      
      <div className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm hover:border-primary/30 transition-all duration-300">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-4 flex-1 min-w-0">
            {/* Book Icon Container */}
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 text-primary border border-primary/20">
              <BookOpen size={24} />
            </div>

            {/* Info details */}
            <div className="flex-1 min-w-0">
              <span className="inline-block text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full bg-secondary/15 text-secondary mb-1 border border-secondary/10">
                {item.category} — {item.topic}
              </span>
              
              <h3 className="font-bold text-base text-foreground line-clamp-1">
                {item.title}
              </h3>
              
              <p className="text-xs text-muted-foreground mt-0.5">
                {item.lastOpened}
              </p>

              {/* Progress Bar Section */}
              <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3 max-w-xl">
                <span className="text-xs font-bold text-muted-foreground">Progress</span>
                <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden relative border border-border/10">
                  <div 
                    className="h-full bg-primary rounded-full transition-all duration-500"
                    style={{ width: `${item.progress}%` }}
                  />
                </div>
                <span className="text-xs font-black text-foreground">{item.progress}%</span>
              </div>
            </div>
          </div>

          {/* Continue button */}
          <button 
            onClick={handleContinue}
            className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl bg-primary text-primary-foreground font-bold hover:bg-primary/95 transition-all text-xs border-none cursor-pointer shadow-sm group whitespace-nowrap self-stretch sm:self-center justify-center"
          >
            <span>Continue</span>
            <ChevronRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContinueLearning;
